export default __webpack_public_path__ + "static/new-logo-eb117f97278cbbb2c46b0a7146a510b0.svg";